export class JobApplicationPage {
    public Index: number
    public JobApplicationsNumber: number

    constructor () {
      this.Index = 0
      this.JobApplicationsNumber = 25
    }
}
